'use client';

import React, { JSX } from 'react';

import { Button, Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@videoblocks/design-system';

interface AiRiskModalProps {
    isOpen: boolean;
    onAccept: () => void;
    onClose: () => void;
}

const AiRiskModal = ({ isOpen, onAccept, onClose }: AiRiskModalProps): JSX.Element => {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="!max-w-[640px] [&_button]:cursor-pointer gap-8">
                <DialogHeader>
                    <DialogTitle className="text-2xl font-bold">Ready to get started?</DialogTitle>
                </DialogHeader>

                <div className="space-y-4 text-sm">
                    <div className="text-sm font-normal text-black">
                        By continuing, you confirm that you will not use the service to:
                    </div>

                    <ul className="list-disc text-sm font-normal text-black">
                        <li>
                            Generate content that threatens child safety or depicts real violence, exploitation, or
                            harassment.
                        </li>
                        <li>Create or distribute hateful, extremist, or election-related misinformation.</li>
                        <li>Build or train competing AI models or attempt to disrupt the service.</li>
                        <li>Support harmful, abusive, or illegal purposes.</li>
                        <li>Upload content that infringes on others&apos; rights or unlawful material.</li>
                    </ul>
                </div>

                <DialogFooter className="mt-6">
                    <Button
                        variant="primary"
                        onClick={onAccept}
                        className="[&>button]:rounded-2-5xl [&>button]:bg-yellow-500 [&>button]:py-2 [&>button]:px-8 [&>button>span]:!text-base"
                    >
                        Accept
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default AiRiskModal;
